import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import '../css/Products.css';

const Products = ({ apiUrl }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const prevCategoryRef = useRef('');

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await fetch(`${apiUrl}/products`);
      const data = await response.json();
      setProducts(data);
      setFilteredProducts(data);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const handleSearchQueryChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearch = async () => {
    try {
      const response = await fetch(`${apiUrl}/products`);
      const data = await response.json();

      const filtered = data.filter((product) => {
        const isMatchingCategory =
          selectedCategory === '' || product.category === selectedCategory;
        const isMatchingSearchQuery = product.name
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
        return isMatchingCategory && isMatchingSearchQuery;
      });

      setFilteredProducts(filtered);
    } catch (error) {
      console.error('Error searching products:', error);
    }
  };

  useEffect(() => {
    if (prevCategoryRef.current !== selectedCategory) {
      filterProducts(selectedCategory);
      prevCategoryRef.current = selectedCategory;
    }
  });

  const filterProducts = (category) => {
    const filtered = products.filter((product) => {
      const isMatchingCategory = category === '' || product.category === category;
     
      return isMatchingCategory;
    });
    setFilteredProducts([]);
    setFilteredProducts(filtered);
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  return (
    <div className="product-container">
      <div className="product-header">
        <div className="product-logo">Products</div>
        <nav className="product-nav">
          {/* NavLink for the "All" category */}
          <NavLink
            className="product-nav-item"
            activeclassname="active"
            to="/products"
            onClick={() => handleCategoryClick('')}
          >
            All
          </NavLink>

          {/* NavLink for the "Domestic" category */}
          <NavLink
            className="product-nav-item"
            activeclassname="active"
            to="/products/domestic"
            onClick={() => handleCategoryClick('Domestic')}
          >
            Domestic
          </NavLink>

          {/* NavLink for the "Commercial" category */}
          <NavLink
            className="product-nav-item"
            activeclassname="active"
            to="/products/commercial"
            onClick={() => handleCategoryClick('Commercial')}
          >
            Commercial
          </NavLink>

          {/* NavLink for the "Softeners" category */}
          <NavLink
            className="product-nav-item"
            activeclassname="active"
            to="/products/softeners"
            onClick={() => handleCategoryClick('Softeners')}
          >
            Softeners
          </NavLink>

          {/* NavLink for the "Magnatron" category */}
          <NavLink
            className="product-nav-item"
            activeclassname="active"
            to="/products/magnetic-water-conditioner"
            onClick={() => handleCategoryClick('Magnetic Water Conditioner')}
          >
            Magnatron
          </NavLink>
        </nav>

        <div className="product-search">
          {/* Search input */}
          <input
            type="search"
            className="searchbar"
            placeholder="Search products..."
            value={searchQuery}
            onChange={handleSearchQueryChange}
          />

          {/* Search button */}
          <button type="button" onClick={handleSearch}>
            <i className="fa fa-search"></i>
          </button>
        </div>
      </div>

      <div className="product-list">
        {filteredProducts.length > 0 ? (
          filteredProducts.map((product) => (
            <div className="product-item" key={product.id}>
              <img src={product.image} alt={product.name} className="product-image" />
              <h3 className="text-center">{product.name}</h3>
              <p><strong>Rs. {product.price}/-</strong></p>
              <p>{product.description}</p>
            </div>
          ))
        ) : (
          <p>No products found</p>
        )}
      </div>
    </div>
  );
};

export default Products;
